import { styled, BottomSheetContent as UiBottomSheetContent } from "@l2r-front/l2r-ui"

export const SidebarContent = styled(UiBottomSheetContent)({
    position: "relative",
    height: "100%",
})